import React from "react";
import "./GalleriesFlat.scss";
import img1 from "../../assets/galleries/flat1/img1.jpg";
import img2 from "../../assets/galleries/flat1/img2.jpg";

function GalleryFlat1() {
  return (
    <section className="galleryFlat1">
      <div className="galleryFlat1__photo1">
        <img className="galleryFlat1__photo1__img" src={img1} alt="" />
      </div>

      <div className="galleryFlat1__photo2">
        <img className="galleryFlat1__photo2__img" src={img2} alt="" />
        <p className="galleryFlat1__copy">
          “I find beauty everywhere,” he says, “in nature, in people, in
          architecture, in art and in food.”
        </p>
      </div>
    </section>
  );
}

export default GalleryFlat1;
